<template>
  <div :class="[$style.container, $style[theme]]">
    <div v-if="subject" :class="$style.subject">{{ $t('chat.subject') }}: {{ subject }}</div>
    <div>
      <span v-html="messageText" style="white-space: pre-wrap" ref="text"></span>
      <span v-if="message.translatedMessage" @click.stop="toggleOriginal" :class="$style.showOriginal">
        (<template v-if="showOriginal">{{ $t('translation.showTranslated') }}</template>
        <template v-else>{{ $t('translation.showOriginal') }}</template
        >)
      </span>
    </div>
  </div>
</template>

<script>
import linkifyUrls from 'linkify-urls'
import { mapGetters } from 'vuex'

const REG_FIRST_MENTION = /^(@)([^\s]+)/
const REG_OTHER_MENTIONS = /([\s+])(@)([^\s]+)/g

export default {
  name: 'message-content-text',
  props: {
    message: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showOriginal: false
    }
  },
  watch: {
    messageText: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          this.setEvents()
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      chatById: 'entities/chats/getById'
    }),
    subject () {
      return this.message.properties && this.message.properties.subject
    },
    messageText () {
      if (!this.message.payload) return
      let result =
        this.message.translatedMessage && !this.showOriginal
          ? this.message.translatedMessage.targetText
          : this.message.payload
      result = this.escape(result)
      result = this.linkify(result)
      result = this.mentionize(result)
      return result
    },
    mentions () {
      if (!this.message.payload) return
      const txt = this.message.payload
      const pattern = /\B@[^\s]+/gi
      return txt.match(pattern).map(mention => mention.slice(1))
    },
    mentionedUsers () {
      const chat = this.chatById(this.message.chatId)
      const participants = chat.participantsUsers
      return participants.filter(user => this.mentions.includes(user.nickname))
    }
  },
  methods: {
    escape (text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    linkify (text) {
      return linkifyUrls(text, {
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
          onclick: 'event.stopPropagation()'
        }
      })
    },
    mentionize (text) {
      const onclick = `event.stopPropagation();`
      text = text.replace(REG_FIRST_MENTION, `<span data-nickname="$2" class="link" onclick="${onclick}">$1$2</span>`)
      return text.replace(
        REG_OTHER_MENTIONS,
        `$1<span data-nickname="$3" class="link" onclick="${onclick}">$2$3</span>`
      )
    },
    setEvents () {
      if (!this.$refs.text) return
      const nodeList = this.$refs.text.querySelectorAll('.link')
      nodeList.forEach(node => {
        node.addEventListener('click', () => {
          this.showProfile(node.dataset.nickname)
        })
      })
    },
    showProfile (nickname) {
      const user = this.mentionedUsers.find(user => user.nickname === nickname)
      if (!user) return
      this.$modal.show('profile', {
        userId: user.userId,
        chatId: this.message.chatId
      })
    },
    toggleOriginal () {
      this.showOriginal = !this.showOriginal
    }
  }
}
</script>

<style module lang="scss">
.container {
  font-size: 14px;
  & > div,
  & > div > span {
    display: block;
    font-size: 14px;
    overflow-wrap: break-word;
    white-space: pre-wrap;
  }
}
.green {
  .subject {
    color: $white;
  }
  span {
    color: $white;
  }

  .showOriginal {
    color: $white;
  }
}

.subject {
  font-size: 12px;
  font-weight: 500;
  color: $text-mid;
}

.showOriginal {
  margin-left: 2px;
  font-size: 10px;
  color: $text-colored;
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
}
</style>
